import './inboxsdk-NONREMOTE-setup';
import * as SDK from './inboxsdk';

export default SDK;
